import { API_BASE_URL } from 'config';

const V1 = `${API_BASE_URL}/api/v1`;
const ACCOUNTS = `${V1}/accounts/web`;
const GENERAL = `${V1}/general`;
const PUBLIC_ADDRESSES = `${V1}/addresses`;
const GROUNDS = `${V1}/grounds/web`;
const BOOKINGS = `${V1}/bookings/web`;
const REPORTS = `${V1}/reports/web`;
const ANALYTICS = `${V1}/analytics`;
const NOTIFICATIONS = `${V1}/notifications/web`;

export const endpoints = {
  LOGIN: `${ACCOUNTS}/auth/login/`,
  REFRESH_TOKEN: (id) => `${ACCOUNTS}/auth/refresh-token/`,
  CHANGE_PASSWORD: `${ACCOUNTS}/auth/change-password/`,

  // Profile
  PROFILE: `${ACCOUNTS}/profile/`,

  // User endpoints
  USERS: `${ACCOUNTS}/users/`,
  SEARCH_PLAYERS: `${GENERAL}/search/players/`,

  // Role endpoints
  ROLES: `${ACCOUNTS}/sub-roles/`,
  ROLE_DETAIL: (id) => `${ACCOUNTS}/sub-roles/${id}/`,
  SUBROLES_BY_ROLE: () => `${ACCOUNTS}/sub-roles/by-role/`,

  // Cities endpoint
  CITIES: `${PUBLIC_ADDRESSES}/cities/`,

  // Ground endpoints
  GROUNDS: `${GROUNDS}/`,
  GROUND_DETAIL: (id) => `${GROUNDS}/${id}/`,
  GROUND_APPROVE: (id) => `${GROUNDS}/${id}/approve/`,
  SEARCH_GROUNDS: `${GENERAL}/search/grounds`,

  // Slot endpoints
  FIELDS: `${GROUNDS}/fields/`,
  FIELDS_DETAIL: (id) => `${GROUNDS}/fields/${id}/`,
  FIELDS_DETAIL_WITH_BOOKINGS: (id) => `${GROUNDS}/fields/${id}/detail-with-bookings/`,

  // Maintenance endpoints
  MAINTENANCE: `${GROUNDS}/maintenance/`,
  MAINTENANCE_DETAIL: (id) => `${GROUNDS}/maintenance/${id}/`,
  MAINTENANCE_BY_GROUND: (groundId) => `${GROUNDS}/maintenance/by-ground/${groundId}/`,
  MAINTENANCE_BY_FIELD: (fieldId) => `${GROUNDS}/maintenance/by-field/${fieldId}/`,

  // Sports endpoint
  SPORTS: `${GENERAL}/sports/`,

  // Amenities endpoint
  AMENITIES: `${GENERAL}/amenities/`,

  // Booking endpoints
  BOOKINGS: `${BOOKINGS}/`,
  BOOKING_DETAIL: (id) => `${BOOKINGS}/${id}/`,
  BOOKING_STATUS: (id) => `${BOOKINGS}/${id}/status/`,
  BOOKING_CALENDAR: `${BOOKINGS}/calendar/`,

  // Offline Booking endpoints
  OFFLINE_BOOKINGS: `${BOOKINGS}/offline/`,
  OFFLINE_BOOKING_DETAIL: (id) => `${BOOKINGS}/offline/${id}/`,
  OFFLINE_BOOKING_STATUS: (id) => `${BOOKINGS}/offline/${id}/status/`,

  // Report endpoints
  REPORTS: `${REPORTS}/`,
  REPORT_DETAIL: (id) => `${REPORTS}/${id}/`,
  REPORT_RESOLVE: (id) => `${REPORTS}/${id}/resolve/`,
  REPORT_DISMISS: (id) => `${REPORTS}/${id}/dismiss/`,
  REPORT_UNDER_REVIEW: (id) => `${REPORTS}/${id}/under-review/`,

  // Analytics endpoints
  ANALYTICS_KPIS: `${ANALYTICS}/kpis/`,
  ANALYTICS_BOOKING_TRENDS: `${ANALYTICS}/booking-trends/`,
  ANALYTICS_REVENUE_BREAKDOWN: `${ANALYTICS}/revenue-breakdown/`,
  ANALYTICS_GROUND_PERFORMANCE: `${ANALYTICS}/ground-performance/`,
  ANALYTICS_USER_ACTIVITY: `${ANALYTICS}/user-activity/`,
  ANALYTICS_BOOKING_HEATMAP: `${ANALYTICS}/booking-heatmap/`,
  ANALYTICS_EXPORT: `${ANALYTICS}/export/`,

  // Ground Admin Earnings endpoints
  GROUND_ADMIN_EARNINGS_SUMMARY: `${ANALYTICS}/ground-admin/earnings-summary/`,
  GROUND_ADMIN_BOOKING_ANALYTICS: `${ANALYTICS}/ground-admin/booking-analytics/`,
  GROUND_ADMIN_REVENUE_BY_SPORT: `${ANALYTICS}/ground-admin/revenue-by-sport/`,
  GROUND_ADMIN_BOOKING_HEATMAP: `${ANALYTICS}/ground-admin/booking-heatmap/`,
  GROUND_ADMIN_TRANSACTION_LEDGER: `${ANALYTICS}/ground-admin/transaction-ledger/`,
  GROUND_ADMIN_DAILY_SLOT_OCCUPANCY: `${ANALYTICS}/ground-admin/daily-slot-occupancy/`,
  GROUND_ADMIN_EXPORT: `${ANALYTICS}/ground-admin/export/`,
  GROUND_ADMIN_WITHDRAWAL_BALANCE: `${ANALYTICS}/ground-admin/withdrawal-balance/`,
  GROUND_ADMIN_WITHDRAWAL_REQUESTS: `${ANALYTICS}/ground-admin/withdrawal-requests/`,

  // Admin withdrawal endpoints
  ADMIN_WITHDRAWAL_REQUESTS: `${ANALYTICS}/withdrawal-requests/`,
  ADMIN_WITHDRAWAL_REQUEST_STATUS: (id) => `${ANALYTICS}/withdrawal-requests/${id}/status/`,

  // Notification endpoints
  NOTIFICATIONS: `${NOTIFICATIONS}/`,
  NOTIFICATION_DETAIL: (id) => `${NOTIFICATIONS}/${id}/`,
  NOTIFICATIONS_UNREAD_COUNT: `${NOTIFICATIONS}/unread_count/`,
  NOTIFICATIONS_MARK_READ: `${NOTIFICATIONS}/mark_read/`,
  NOTIFICATIONS_MARK_ALL_READ: `${NOTIFICATIONS}/mark_all_read/`,
  NOTIFICATION_MARK_SINGLE_READ: (id) => `${NOTIFICATIONS}/${id}/mark_read/`,

};
